import SideMenuRouter from 'mrf/view/SideMenuRouter';
import SystemInfo from "mrf/view/SystemInfo";
import role from 'role';
import Parameter from './parameter';
import User from './user';
import LoginAttempts from './user/LoginAttempts';
import Manual from "mrf/view/Manual";
import LoggedRequests from "mrf/view/LoggedRequests";
import TranslationLanguage from "components/system/translationLanguages/index";
import Token from 'components/system/communicationToken'
import Country from 'components/system/country';
import PublicKey from 'components/system/publicKeys';
import LicenseCommunication from 'components/system/licenseCommunication';
import RootTerm from 'components/system/rootTerm';
import CommunicationProcess from 'components/system/communicationProcess';
import Swagger from "components/system/swagger/SwaggerDocs";
import UserHistory from "mrf/view/UserHistory";
import CommunicationAssignment from 'components/system/communicationAssignment';
import Institution from 'components/system/institution';


const System = ({ match }) => {
    return <SideMenuRouter match={match} menuList={menuList} indexComponent={SystemInfo} />
}

const menuList = [
    {
        title: 'General',
        roleCodes: [role.ADMIN],
        subMenu: [
            {
                title: 'License Communication',
                path: '/licenseCommunication',
                component: LicenseCommunication,
            },
            {
                title: 'Assignments',
                path: '/assignments',
                component: CommunicationAssignment,
            },
            {
                title: 'Communication Transfers',
                path: '/communicationTransfers',
                component: CommunicationProcess,
            },
            {
                title: 'Public Key Repository',
                path: '/publicKey',
                component: PublicKey,
            },
            {
                title: 'Tokens',
                path: '/token',
                component: Token,
            },
            {
                title: 'Countries',
                path: '/country',
                component: Country,
            },
            {
                title: 'Institutions',
                path: '/institution',
                component: Institution,
            },
            {
                title: 'Root Terms',
                path: '/rootTerms',
                component: RootTerm,
            },
        ],
    },
    {
        title: 'Administration',
        roleCodes: [role.ADMIN],
        subMenu: [
            {
                title: 'Users',
                path: '/user',
                component: User,
            },
            {
                title: 'Login Attempts',
                path: '/loginAttempts',
                component: LoginAttempts,
            },
            {
                title: 'Parameters',
                path: '/parameters',
                component: Parameter,
            },
            {
                title: 'System Info',
                path: '/systemInfo',
                component: SystemInfo,
            },
            {
                title: 'Translations',
                path: '/translations',
                component: TranslationLanguage,
            },
            {
                title: 'Manual',
                path: '/manual',
                component: Manual
            },
            {
                title: 'Logged Requests',
                path: '/loggedRequests',
                component: LoggedRequests
            },
            {
                title: 'User History',
                path: '/userHistory',
                component: UserHistory,
            }
        ],
    },
    {
        title: 'API Documentation',
        path: '/apiDocumentation',
        component: Swagger
    }
]

export default System;
